<div class="step-one" [class.step-one--edit]="isEditStepper">
  <div class="step-one__layout">
    <div class="step-one__back">
      <ds-button-v2
        emphasis="terciary"
        size="xs"
        leadingIcon="ArrowBack"
        [label]="isEditStepper ? stepOne.editBack : stepOne.back"
        (clicked)="goBack()"
      ></ds-button-v2>
    </div>

    <div class="step-one__columns">
      <div class="step-one__primary">
        <div class="step-one__heading">
          <p class="step-one__flow">{{ stepOne.flowName }}</p>
          <div class="step-one__heading-text">
            <h2 class="step-one__title">{{ isEditStepper ? stepOne.editTitle : stepOne.title }}</h2>
            <p class="step-one__subtitle">
              {{ isEditStepper ? stepOne.editSubtitle : stepOne.subtitle }}
            </p>
          </div>
        </div>

        <ds-card shadow="l2">
          <form [formGroup]="frmStepOne" class="step-one__card">
            <div class="step-one__card-header">
              <h3 class="step-one__card-title">{{ stepOne.cardTitle }}</h3>
              <p class="step-one__card-subtitle">{{ stepOne.cardSubtitle }}</p>
            </div>

            <div class="step-one__fields">
              <div class="step-one__field">
                <p class="step-one__question">{{ stepOne.unitQuestion }}</p>
                <div class="step-one__units">
                  <ds-tab-button
                    *ngFor="let unit of units"
                    size="md"
                    [label]="unit.label"
                    [selected]="unit.id === frmStepOne.value.currency"
                    (clicked)="selectUnit(unit.id)"
                  ></ds-tab-button>
                </div>
              </div>

              <div class="step-one__field step-one__field--amount">
                <p class="step-one__question">{{ stepOne.amountQuestion }}</p>
                <ds-input-text
                  type="tel"
                  visualTransformation="thousands"
                  [formatAsNumericAmount]="true"
                  [maxCharacters]="amountMaxDigits"
                  [showMaxCharacters]="false"
                  [prefix]="selectedUnit.prefix"
                  [showPrefix]="true"
                  [placeholder]="stepOne.amountPlaceholder"
                  [value]="amountDigits"
                  [state]="hasAmountError ? 'error' : 'default'"
                  [helpText]="amountHelpText"
                  [showHelpText]="true"
                  (valueChange)="onAmountChange($event)"
                  (blurred)="onAmountBlur()"
                ></ds-input-text>
              </div>
            </div>
          </form>
        </ds-card>

        <ds-inline-alert
          class="step-one__notice"
          type="neutral"
          icon="Info"
          size="m"
          [description]="stepOne.notice"
        ></ds-inline-alert>

        <div class="step-one__submit">
          <div class="step-one__submit-action">
            <ds-button-v2
              emphasis="primary"
              size="m"
              [fullWidth]="true"
              maxWidth="100%"
              [disabled]="!canContinue"
              [label]="isEditStepper ? stepOne.editSubmit : stepOne.submitButton"
              (clicked)="isEditStepper ? saveChanges() : goToNextStep()"
            ></ds-button-v2>
          </div>
        </div>
      </div>

      <app-stepper-lateral
        *ngIf="!isEditStepper"
        class="step-one__stepper"
        [currentStep]="currentStepIndex"
      ></app-stepper-lateral>
    </div>
  </div>
</div>
